import { chipsBurned } from "./chips-burned";
import { deliveredProductsByBar } from "./delivered-products-by-bar";
import { detailedTransactions } from "./detailed-transactions";
import { salesReport } from "./sales-report";
import { soldBaseProductReport } from "./sold-base-product-report";
import { soldProducts } from "./sold-products";
import { soldProductsV2 } from "./sold-products-v2";
import { soldRankingReport } from "./sold-ranking-report";
import { waiterReport } from "./waiter-report";

export const barReports = {
	printDate: "Emitido el día",
	reportPeriod: "Período del informe",
	filter: "Filtrar por tipo de transacción",
	filterPlaceholder: "Seleccione un tipo de transacción",
	filterOptions: {
		all: "Todos",
		balcony: "Barra",
		cashless: "Cashless",
		dash: "Dashboard",
		delivery: "Delivery",
		ficha: "Ficha",
		grabngo: "Grab n Go",
		onlineBill: "Comanda Online",
		zigQrcode: "QR Code Zig",
	},
	soldProducts,
	soldProductsV2,
	detailedTransactions,
	salesReport,
	chipsBurned,
	waiterReport,
	deliveredProductsByBar,
	soldBaseProductReport,
	soldRankingReport,
	tipReport: {
		title: "Informe de Propina",
		filename: "informe-de-propina_{{date}}",
		subtitle:
			"Relación de valores a ser recibidos por los operadores/meseros referente a las propinas de servicio.",
		filterByPeriod: "Filtrar por período",
		filterByEmployee: "Filtrar por empleado",
		filterByEmployeePlaceholder: "Seleccione el(los) empleado(s)",
		eventPeriod: "Período del evento",
		statusRunning: "(en curso)",
		columns: {
			name: "Nombre",
			total: "Total en propinas",
			extraTip: "Propina extra",
			cashTotal: "Efectivo",
			debitTotal: "Débito",
			creditTotal: "Crédito",
			appTotal: "App",
			pixTotal: "Pix",
			bonusTotal: "Bono",
		},
		tooltip: {
			total: "Total en propinas (según % definido por el local)",
			extraTip: "Valor de propina que excede la tasa de servicio definida por el local",
		},
		alert: {
			title: "Atención",
			message:
				"El total en propinas incluye cuentas abiertas, lo que puede generar diferencias en los valores totales de las formas de pago. Las formas de pago se actualizarán después del cierre de la cuenta abierta.",
		},
	},
	yes: "Sí",
	no: "No",
	noCard: "Sin tarjeta",
	grams: "gramos",
	kilos: "Kilos",
	liter: "Litros",
	by: "por",
	productReturnsReport: {
		title: "Devolución de producto",
		product: "Producto",
		quantity: "CANT",
		returnValue: "Valor de la devolución",
		totalValue: "Total",
		noRecords: "Sin registros",
		noReturnedProducts: "No hubo devoluciones en este período",
		noReturnsThisEvent: "No hubo devoluciones en este evento",
		productReturnReport: "Informe de devolución de productos",
		totalReturnedProducts: "Total de productos devueltos",
		productsReturnedByEmployee: "Productos devueltos por empleado",
		employee: "Empleado",
		summary: "Resumen",
	},
};
